document.addEventListener('DOMContentLoaded', function () {
    const link = document.querySelector('.entertainment-detail__link');
    const description = document.querySelector('.entertainment-detail__description-more');

    if (description) {
        link.addEventListener('click', function () {
            description.classList.toggle('entertainment-detail__description-more--show');
            link.classList.toggle('entertainment-detail__link--show');

            setTimeout(function () {
                if (link.classList.contains('entertainment-detail__link--show')) {
                    link.textContent = 'Скрыть';
                } else {
                    link.textContent = 'Подробнее';
                }
            }, 200);
        });
    }
});